var Locales = /* @__PURE__ */ ((Locales2) => {
  Locales2["AFRIKAANS"] = "af";
  Locales2["AFRIKAANS_SOUTH_AFRICA"] = "af-ZA";
  Locales2["ARABIC"] = "ar";
  Locales2["ARABIC_UNITED_ARAB_EMIRATES"] = "ar-AE";
  Locales2["ARABIC_BAHRAIN"] = "ar-BH";
  Locales2["ARABIC_ALGERIA"] = "ar-DZ";
  Locales2["ARABIC_EGYPT"] = "ar-EG";
  Locales2["ARABIC_IRAQ"] = "ar-IQ";
  Locales2["ARABIC_JORDAN"] = "ar-JO";
  Locales2["ARABIC_KUWAIT"] = "ar-KW";
  Locales2["ARABIC_LEBANON"] = "ar-LB";
  Locales2["ARABIC_LIBYA"] = "ar-LY";
  Locales2["ARABIC_MOROCCO"] = "ar-MA";
  Locales2["ARABIC_OMAN"] = "ar-OM";
  Locales2["ARABIC_QATAR"] = "ar-QA";
  Locales2["ARABIC_SAUDI_ARABIA"] = "ar-SA";
  Locales2["ARABIC_SYRIA"] = "ar-SY";
  Locales2["ARABIC_TUNISIA"] = "ar-TN";
  Locales2["ARABIC_YEMEN"] = "ar-YE";
  Locales2["AZERI_LATIN"] = "az";
  Locales2["AZERI_LATIN_AZERBAIJAN"] = "az-AZ";
  Locales2["BELARUSIAN"] = "be";
  Locales2["BELARUSIAN_BELARUS"] = "be-BY";
  Locales2["BULGARIAN"] = "bg";
  Locales2["BULGARIAN_BULGARIA"] = "bg-BG";
  Locales2["BOSNIAN"] = "bs";
  Locales2["BOSNIAN_BOSNIA_AND_HERZEGOVINA"] = "bs-BA";
  Locales2["CATALAN"] = "ca";
  Locales2["CATALAN_SPAIN"] = "ca-ES";
  Locales2["CZECH"] = "cs";
  Locales2["CZECH_CZECH_REPUBLIC"] = "cs-CZ";
  Locales2["WELSH"] = "cy";
  Locales2["WELSH_UNITED_KINGDOM"] = "cy-GB";
  Locales2["DANISH"] = "da";
  Locales2["DANISH_DENMARK"] = "da-DK";
  Locales2["GERMAN"] = "de";
  Locales2["GERMAN_AUSTRIA"] = "de-AT";
  Locales2["GERMAN_SWITZERLAND"] = "de-CH";
  Locales2["GERMAN_GERMANY"] = "de-DE";
  Locales2["GERMAN_LIECHTENSTEIN"] = "de-LI";
  Locales2["GERMAN_LUXEMBOURG"] = "de-LU";
  Locales2["DIVEHI"] = "dv";
  Locales2["DIVEHI_MALDIVES"] = "dv-MV";
  Locales2["GREEK"] = "el";
  Locales2["GREEK_GREECE"] = "el-GR";
  Locales2["ENGLISH"] = "en";
  Locales2["ENGLISH_AUSTRALIA"] = "en-AU";
  Locales2["ENGLISH_BELIZE"] = "en-BZ";
  Locales2["ENGLISH_CANADA"] = "en-CA";
  Locales2["ENGLISH_CARIBBEAN"] = "en-CB";
  Locales2["ENGLISH_UNITED_KINGDOM"] = "en-GB";
  Locales2["ENGLISH_IRELAND"] = "en-IE";
  Locales2["ENGLISH_JAMAICA"] = "en-JM";
  Locales2["ENGLISH_NEW_ZEALAND"] = "en-NZ";
  Locales2["ENGLISH_PHILIPPINES"] = "en-PH";
  Locales2["ENGLISH_TRINIDAD_AND_TOBAGO"] = "en-TT";
  Locales2["ENGLISH_UNITED_STATES"] = "en-US";
  Locales2["ENGLISH_SOUTH_AFRICA"] = "en-ZA";
  Locales2["ENGLISH_ZIMBABWE"] = "en-ZW";
  Locales2["ESPERANTO"] = "eo";
  Locales2["SPANISH"] = "es";
  Locales2["SPANISH_ARGENTINA"] = "es-AR";
  Locales2["SPANISH_BOLIVIA"] = "es-BO";
  Locales2["SPANISH_CHILE"] = "es-CL";
  Locales2["SPANISH_COLOMBIA"] = "es-CO";
  Locales2["SPANISH_COSTA_RICA"] = "es-CR";
  Locales2["SPANISH_DOMINICAN_REPUBLIC"] = "es-DO";
  Locales2["SPANISH_ECUADOR"] = "es-EC";
  Locales2["SPANISH_SPAIN"] = "es-ES";
  Locales2["SPANISH_GUATEMALA"] = "es-GT";
  Locales2["SPANISH_HONDURAS"] = "es-HN";
  Locales2["SPANISH_MEXICO"] = "es-MX";
  Locales2["SPANISH_NICARAGUA"] = "es-NI";
  Locales2["SPANISH_PANAMA"] = "es-PA";
  Locales2["SPANISH_PERU"] = "es-PE";
  Locales2["SPANISH_PUERTO_RICO"] = "es-PR";
  Locales2["SPANISH_PARAGUAY"] = "es-PY";
  Locales2["SPANISH_EL_SALVADOR"] = "es-SV";
  Locales2["SPANISH_URUGUAY"] = "es-UY";
  Locales2["SPANISH_VENEZUELA"] = "es-VE";
  Locales2["ESTONIAN"] = "et";
  Locales2["ESTONIAN_ESTONIA"] = "et-EE";
  Locales2["BASQUE"] = "eu";
  Locales2["BASQUE_SPAIN"] = "eu-ES";
  Locales2["FARSI"] = "fa";
  Locales2["FARSI_IRAN"] = "fa-IR";
  Locales2["FINNISH"] = "fi";
  Locales2["FINNISH_FINLAND"] = "fi-FI";
  Locales2["FAROESE"] = "fo";
  Locales2["FAROESE_FAROE_ISLANDS"] = "fo-FO";
  Locales2["FRENCH"] = "fr";
  Locales2["FRENCH_BELGIUM"] = "fr-BE";
  Locales2["FRENCH_CANADA"] = "fr-CA";
  Locales2["FRENCH_SWITZERLAND"] = "fr-CH";
  Locales2["FRENCH_FRANCE"] = "fr-FR";
  Locales2["FRENCH_LUXEMBOURG"] = "fr-LU";
  Locales2["FRENCH_PRINCIPALITY_OF_MONACO"] = "fr-MC";
  Locales2["GALICIAN"] = "gl";
  Locales2["GALICIAN_SPAIN"] = "gl-ES";
  Locales2["GUJARATI"] = "gu";
  Locales2["GUJARATI_INDIA"] = "gu-IN";
  Locales2["HEBREW"] = "he";
  Locales2["HEBREW_ISRAEL"] = "he-IL";
  Locales2["HINDI"] = "hi";
  Locales2["HINDI_INDIA"] = "hi-IN";
  Locales2["CROATIAN"] = "hr";
  Locales2["CROATIAN_BOSNIA_AND_HERZEGOVINA"] = "hr-BA";
  Locales2["CROATIAN_CROATIA"] = "hr-HR";
  Locales2["HUNGARIAN"] = "hu";
  Locales2["HUNGARIAN_HUNGARY"] = "hu-HU";
  Locales2["ARMENIAN"] = "hy";
  Locales2["ARMENIAN_ARMENIA"] = "hy-AM";
  Locales2["INDONESIAN"] = "id";
  Locales2["INDONESIAN_INDONESIA"] = "id-ID";
  Locales2["ICELANDIC"] = "is";
  Locales2["ICELANDIC_ICELAND"] = "is-IS";
  Locales2["ITALIAN"] = "it";
  Locales2["ITALIAN_SWITZERLAND"] = "it-CH";
  Locales2["ITALIAN_ITALY"] = "it-IT";
  Locales2["JAPANESE"] = "ja";
  Locales2["JAPANESE_JAPAN"] = "ja-JP";
  Locales2["GEORGIAN"] = "ka";
  Locales2["GEORGIAN_GEORGIA"] = "ka-GE";
  Locales2["KAZAKH"] = "kk";
  Locales2["KAZAKH_KAZAKHSTAN"] = "kk-KZ";
  Locales2["KANNADA"] = "kn";
  Locales2["KANNADA_INDIA"] = "kn-IN";
  Locales2["KOREAN"] = "ko";
  Locales2["KOREAN_KOREA"] = "ko-KR";
  Locales2["KONKANI"] = "kok";
  Locales2["KONKANI_INDIA"] = "kok-IN";
  Locales2["KYRGYZ"] = "ky";
  Locales2["KYRGYZ_KYRGYZSTAN"] = "ky-KG";
  Locales2["LITHUANIAN"] = "lt";
  Locales2["LITHUANIAN_LITHUANIA"] = "lt-LT";
  Locales2["LATVIAN"] = "lv";
  Locales2["LATVIAN_LATVIA"] = "lv-LV";
  Locales2["MAORI"] = "mi";
  Locales2["MAORI_NEW_ZEALAND"] = "mi-NZ";
  Locales2["FYRO_MACEDONIAN"] = "mk";
  Locales2["FYRO_MACEDONIAN_MACEDONIA"] = "mk-MK";
  Locales2["MONGOLIAN"] = "mn";
  Locales2["MONGOLIAN_MONGOLIA"] = "mn-MN";
  Locales2["MARATHI"] = "mr";
  Locales2["MARATHI_INDIA"] = "mr-IN";
  Locales2["MALAY"] = "ms";
  Locales2["MALAY_BRUNEI_DARUSSALAM"] = "ms-BN";
  Locales2["MALAY_MALAYSIA"] = "ms-MY";
  Locales2["MALTESE"] = "mt";
  Locales2["MALTESE_MALTA"] = "mt-MT";
  Locales2["NORWEGIAN_BOKMAL"] = "nb";
  Locales2["NORWEGIAN_BOKMAL_NORWAY"] = "nb-NO";
  Locales2["DUTCH"] = "nl";
  Locales2["DUTCH_BELGIUM"] = "nl-BE";
  Locales2["DUTCH_NETHERLANDS"] = "nl-NL";
  Locales2["NORWEGIAN_NYNORSK_NORWAY"] = "nn-NO";
  Locales2["NORTHERN_SOTHO"] = "ns";
  Locales2["NORTHERN_SOTHO_SOUTH_AFRICA"] = "ns-ZA";
  Locales2["PUNJABI"] = "pa";
  Locales2["PUNJABI_INDIA"] = "pa-IN";
  Locales2["POLISH"] = "pl";
  Locales2["POLISH_POLAND"] = "pl-PL";
  Locales2["PASHTO"] = "ps";
  Locales2["PASHTO_AFGHANISTAN"] = "ps-AR";
  Locales2["PORTUGUESE"] = "pt";
  Locales2["PORTUGUESE_BRAZIL"] = "pt-BR";
  Locales2["PORTUGUESE_PORTUGAL"] = "pt-PT";
  Locales2["QUECHUA"] = "qu";
  Locales2["QUECHUA_BOLIVIA"] = "qu-BO";
  Locales2["QUECHUA_ECUADOR"] = "qu-EC";
  Locales2["QUECHUA_PERU"] = "qu-PE";
  Locales2["ROMANIAN"] = "ro";
  Locales2["ROMANIAN_ROMANIA"] = "ro-RO";
  Locales2["RUSSIAN"] = "ru";
  Locales2["RUSSIAN_RUSSIA"] = "ru-RU";
  Locales2["SANSKRIT"] = "sa";
  Locales2["SANSKRIT_INDIA"] = "sa-IN";
  Locales2["SAMI_NORTHERN"] = "se";
  Locales2["SAMI_NORTHERN_FINLAND"] = "se-FI";
  Locales2["SAMI_NORTHERN_NORWAY"] = "se-NO";
  Locales2["SAMI_NORTHERN_SWEDEN"] = "se-SE";
  Locales2["SLOVAK"] = "sk";
  Locales2["SLOVAK_SLOVAKIA"] = "sk-SK";
  Locales2["SLOVENIAN"] = "sl";
  Locales2["SLOVENIAN_SLOVENIA"] = "sl-SI";
  Locales2["ALBANIAN"] = "sq";
  Locales2["ALBANIAN_ALBANIA"] = "sq-AL";
  Locales2["SERBIAN_LATIN"] = "sr";
  Locales2["SERBIAN_LATIN_BOSNIA_AND_HERZEGOVINA"] = "sr-BA";
  Locales2["SERBIAN_LATIN_SERBIA_AND_MONTENEGRO"] = "sr-SP";
  Locales2["SWEDISH"] = "sv";
  Locales2["SWEDISH_FINLAND"] = "sv-FI";
  Locales2["SWEDISH_SWEDEN"] = "sv-SE";
  Locales2["SWAHILI"] = "sw";
  Locales2["SWAHILI_KENYA"] = "sw-KE";
  Locales2["SYRIAC"] = "syr";
  Locales2["SYRIAC_SYRIA"] = "syr-SY";
  Locales2["TAMIL"] = "ta";
  Locales2["TAMIL_INDIA"] = "ta-IN";
  Locales2["TELUGU"] = "te";
  Locales2["TELUGU_INDIA"] = "te-IN";
  Locales2["THAI"] = "th";
  Locales2["THAI_THAILAND"] = "th-TH";
  Locales2["TAGALOG"] = "tl";
  Locales2["TAGALOG_PHILIPPINES"] = "tl-PH";
  Locales2["TSWANA"] = "tn";
  Locales2["TSWANA_SOUTH_AFRICA"] = "tn-ZA";
  Locales2["TURKISH"] = "tr";
  Locales2["TURKISH_TURKEY"] = "tr-TR";
  Locales2["TATAR"] = "tt";
  Locales2["TATAR_RUSSIA"] = "tt-RU";
  Locales2["TSOGA"] = "ts";
  Locales2["UKRAINIAN"] = "uk";
  Locales2["UKRAINIAN_UKRAINE"] = "uk-UA";
  Locales2["URDU"] = "ur";
  Locales2["URDU_ISLAMIC_REPUBLIC_OF_PAKISTAN"] = "ur-PK";
  Locales2["UZBEK_LATIN"] = "uz";
  Locales2["UZBEK_LATIN_UZBEKISTAN"] = "uz-UZ";
  Locales2["VIETNAMESE"] = "vi";
  Locales2["VIETNAMESE_VIET_NAM"] = "vi-VN";
  Locales2["XHOSA"] = "xh";
  Locales2["XHOSA_SOUTH_AFRICA"] = "xh-ZA";
  Locales2["CHINESE"] = "zh";
  Locales2["CHINESE_SIMPLIFIED"] = "zh-Hans";
  Locales2["CHINESE_SIMPLIFIED_CHINA"] = "zh-CN";
  Locales2["CHINESE_HONG_KONG"] = "zh-HK";
  Locales2["CHINESE_MACAU"] = "zh-MO";
  Locales2["CHINESE_SINGAPORE"] = "zh-SG";
  Locales2["CHINESE_TRADITIONAL"] = "zh-Hant";
  Locales2["ZULU"] = "zu";
  Locales2["ZULU_SOUTH_AFRICA"] = "zu-ZA";
  Locales2["BENGALI"] = "bn";
  Locales2["BENGALI_BANGLADESH"] = "bn-BD";
  Locales2["BENGALI_INDIA"] = "bn-IN";
  Locales2["BENGALI_MYANMAR"] = "bn-MM";
  Locales2["BURMESE"] = "my";
  Locales2["BURMESE_MYANMAR"] = "my-MM";
  Locales2["KHMER"] = "km";
  Locales2["KHMER_CAMBODIA"] = "km-KH";
  Locales2["LAO"] = "lo";
  Locales2["LAO_LAOS"] = "lo-LA";
  Locales2["YORUBA"] = "yo";
  Locales2["YORUBA_NIGERIA"] = "yo-NG";
  Locales2["AMHARIC"] = "am";
  Locales2["AMHARIC_ETHIOPIA"] = "am-ET";
  Locales2["NEPALI"] = "ne";
  Locales2["NEPALI_NEPAL"] = "ne-NP";
  Locales2["SINHALA"] = "si";
  Locales2["SINHALA_SRI_LANKA"] = "si-LK";
  Locales2["SERBIAN_CYRILLIC"] = "sr-Cyrl";
  Locales2["SERBIAN_CYRILLIC_SERBIA"] = "sr-RS";
  Locales2["SERBIAN_CYRILLIC_BOSNIA_AND_HERZEGOVINA"] = "sr-BA";
  Locales2["ENGLISH_INDIA"] = "en-IN";
  Locales2["ENGLISH_SINGAPORE"] = "en-SG";
  Locales2["ENGLISH_HONG_KONG"] = "en-HK";
  Locales2["ENGLISH_NIGERIA"] = "en-NG";
  Locales2["ENGLISH_PAKISTAN"] = "en-PK";
  Locales2["ENGLISH_MALAYSIA"] = "en-MY";
  Locales2["ENGLISH_BOTSWANA"] = "en-BW";
  Locales2["ENGLISH_KENYA"] = "en-KE";
  Locales2["ENGLISH_TANZANIA"] = "en-TZ";
  Locales2["ENGLISH_GHANA"] = "en-GH";
  Locales2["ENGLISH_UGANDA"] = "en-UG";
  Locales2["SPANISH_CUBA"] = "es-CU";
  Locales2["SPANISH_UNITED_STATES"] = "es-US";
  Locales2["PORTUGUESE_GUINEA_BISSAU"] = "pt-GW";
  Locales2["PORTUGUESE_MOZAMBIQUE"] = "pt-MZ";
  Locales2["PORTUGUESE_SAO_TOME_AND_PRINCIPE"] = "pt-ST";
  Locales2["PORTUGUESE_CAPE_VERDE"] = "pt-CV";
  Locales2["PORTUGUESE_TIMOR_LESTE"] = "pt-TL";
  Locales2["PORTUGUESE_MACAU"] = "pt-MO";
  Locales2["CHINESE_TAIWAN"] = "zh-TW";
  Locales2["ARABIC_MAURITANIA"] = "ar-MR";
  Locales2["ARABIC_PALESTINE"] = "ar-PS";
  Locales2["ARABIC_SUDAN"] = "ar-SD";
  Locales2["ARABIC_DJIBOUTI"] = "ar-DJ";
  Locales2["ARABIC_SOMALIA"] = "ar-SO";
  Locales2["ARABIC_CHAD"] = "ar-TD";
  Locales2["ARABIC_COMOROS"] = "ar-KM";
  return Locales2;
})(Locales || {});
export {
  Locales
};
//# sourceMappingURL=locales.mjs.map